module.exports = require("git-url-parse");